import { render, staticRenderFns } from "./SkillItem.vue?vue&type=template&id=2b167184&scoped=true"
import script from "./SkillItem.vue?vue&type=script&lang=js"
export * from "./SkillItem.vue?vue&type=script&lang=js"
import style0 from "./SkillItem.vue?vue&type=style&index=0&id=2b167184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b167184",
  null
  
)

export default component.exports